(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("../../components/Icon"), require("../../utils/css-validator"));
	else if(typeof define === 'function' && define.amd)
		define(["../../components/Icon", "../../utils/css-validator"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("../../components/Icon"), require("../../utils/css-validator")) : factory(root["../../components/Icon"], root["../../utils/css-validator"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__20__, __WEBPACK_EXTERNAL_MODULE__948__) {
return 